import React, { useState } from 'react';
import { Card, Breadcrumb, Input, Row, Col, List, Spin, DatePicker, Button, Typography } from 'antd';
import Background from '../../../../static/img/bg-list-title.png';
import { queryOpenAPIAppList } from './gqls'
import Client from '../../../../lib/gqlClient';
import moment from 'moment-timezone';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
const APIAuthorizationInformation = (props) => {
    const navigate = useNavigate();
    const { Paragraph, Text } = Typography;
    const [isGetData, setIsGetData] = useState(false)
    const [seatchData, setSeatchData] = useState('')
    const [page, setPage] = useState(1)
    const [showSize, setShowSize] = useState(8)
    const [solutionsList,setSolutionsList] = useState([])
    const [dataList, setDataList] = useState([])
    const [startDate, setStartDate] = useState()
    const [endDate, seteEndDate] = useState()
    const [total, setTotal] = useState(1)
    const { RangePicker } = DatePicker;
    React.useEffect(() => {
        onSearch()
    }, [])
    function onInPut(value) {
        console.log(value.target.value);
        setSeatchData(value.target.value)
    }
    function onSearch() {
        getList(seatchData, page, showSize, startDate, endDate)
    }
    function getList(value, page, count, startDate, endDate) {
        setIsGetData(true)
        if (count !== showSize) {
            setShowSize(count)
        }
        Client(
            queryOpenAPIAppList,
            {
                isPermanent: true,
                page: page,
                count: count,
                name: value,
                startDate:startDate,
                endDate:endDate,
            }
        ).then((res) => {
            console.log(res)
            if (res !== null) {
                let list = [""];
                res.data.openAPIAppList.data.map((item, index) => {
                    let solutions = ''
                    item.solutions.map((item2, index2) => {
                        if (solutions === "") {
                            solutions = item2
                        } else {
                            solutions = solutions + "\n" + item2
                        }
                    })
                    list[index] = solutions
                })
                setSolutionsList(list)
                setDataList(res.data.openAPIAppList.data)
                setTotal(res.data.openAPIAppList.total)
            }
            setIsGetData(false)
        }).catch(e => {
            setSolutionsList([])
                setDataList([])
                setTotal()
            setIsGetData(false)
        })
    }

    function onChange(date, dateString) {
        console.log(date, dateString);
        if (date != null) {
            const start = moment(date[0]).valueOf()
            const end = moment(date[1]).valueOf()
            setStartDate(start)
            seteEndDate(end)
            getList(seatchData, page,showSize, start, end)
        } else {
            setStartDate('')
            seteEndDate('')
            getList(seatchData, page,showSize,)
        }


    }

    function onStart() {
        props.setNewKey('developerCenter/apiDataNoticfication')
        navigate('/developerCenter/apiDataNoticfication')

    }
    return (
        <div style={{ height: '100%', width: '100%', }}>

            {/* 标题头 */}
            <div style={{ height: '200px', padding: '0px', backgroundColor: 'white', borderRadius: '2px' }}>
                <Breadcrumb style={{ marginLeft: '20px', paddingTop: "6px" }}>
                    <Breadcrumb.Item><Link to='../../../home' style={{ fontSize: '12px' }}>首页</Link></Breadcrumb.Item>
                    <Breadcrumb.Item><a onClick={onStart} style={{ fontSize: '12px' }}>API Dashboard</a></Breadcrumb.Item>
                    <Breadcrumb.Item><a style={{ fontSize: '12px' }}>授权信息</a></Breadcrumb.Item>
                </Breadcrumb>
                <div style={Styles.title}>搜索授权信息</div>
                <Row style={Styles.search}>
                    <Col>
                        <div >
                            <Input
                                placeholder="请输入 Client Name(Developer email address)\App Name\Client ID"
                                size="large"
                                style={{
                                    width: '556px',
                                    borderRadius: '2px',
                                    height: '46px'
                                }}
                                onChange={onInPut}
                                onPressEnter={onSearch}
                            />
                        </div></Col>
                    <Col>
                        <Button style={{ height: '46px', width: '80px', background: '#FF5300', color: 'white' }} onClick={onSearch}>搜索</Button>
                    </Col>
                </Row>

            </div>


            <Card bordered={false} style={{ marginTop: '25px', marginBottom: '25px', padding: '0px', }}>
                <div style={Styles.listTitle}>授权信息</div>
                <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'center', }}>
                    <RangePicker onChange={onChange} style={{ height: '32px', width: '256px', marginRight: '32px', }} />

                </div>
                <Row style={Styles.listTitleBg}>
                    <Col span={5} style={Styles.listTitleText}>
                        Client
                    </Col>
                    <Col span={4} style={Styles.listTitleText}>
                        Client App Name
                    </Col>
                    <Col span={5} style={Styles.listTitleText}>
                        Client ID
                    </Col>
                    <Col span={2} style={Styles.listTitleText}>
                        Organization
                    </Col>
                    <Col span={2} style={Styles.listTitleText}>
                        Solutions
                    </Col>
                    <Col span={3} style={Styles.listTitleText}>
                        Expired Time
                    </Col>
                    <Col span={3} style={Styles.listTitleText}>
                        Last Change Time
                    </Col>

                </Row>
                <Spin size="large" tip="Loading..." spinning={isGetData}>
                    <List
                        itemLayout="vertical"
                        split="true"
                        pagination={{
                            onChange: (page, pageSize) => {
                                setPage(page)
                                console.log(page);
                                getList(seatchData, page, pageSize, startDate, endDate)

                            },
                            pageSize: showSize,
                            hideOnSinglePage: true,
                            pageSizeOptions: [8, 10, 15, 20, 30, 50, 80, 100],
                            current: page,
                            total: total
                        }}
                        position="bottom"
                        dataSource={dataList}
                        renderItem={(item,index) => (
                            <List.Item>
                                <Row style={Styles.item}>
                                    <Col span={5} style={Styles.listTitleText}>
                                        <Paragraph>{item.client}</Paragraph>
                                    </Col>
                                    <Col span={4} style={Styles.listTitleText}>
                                        <Paragraph>{item.appName}</Paragraph>
                                    </Col>
                                    <Col span={5} style={Styles.listTitleText}>
                                        <Paragraph>{item.clientId}</Paragraph>
                                    </Col>
                                    <Col span={2} style={Styles.listTitleText}>
                                        <Paragraph>{item.organization}</Paragraph>
                                    </Col>
                                    <Col span={2} style={Styles.listTitleText}>
                                    <Paragraph
                                            style={{ whiteSpace: 'pre-line' }}
                                            ellipsis={{
                                                symbol: 'more',
                                            }}
                                        >{solutionsList[index]}</Paragraph>
                                    </Col>
                                    <Col span={3} style={Styles.listTitleText}>
                                        <Paragraph>{item.expiredTime}</Paragraph>
                                    </Col>
                                    <Col span={3} style={Styles.listTitleText}>
                                        <Paragraph>{item.lastChangeTime}</Paragraph>
                                    </Col>
                                </Row>
                            </List.Item>
                        )}
                    />
                </Spin>
            </Card>

        </div>
    );

}

const { Search } = Input;
const Styles = {
    title: {
        display: 'block',
        fontSize: '20px',
        color: '#000000',
        marginLeft: '150px',
        marginTop: '30px'
    },
    search: {
        color: '#2D3238',
        height: '46px',
        marginTop: '30px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    listTitle: {
        display: 'block',
        fontSize: '16px',
        color: '#000000',
        marginTop: '25px',
        textAlign: 'center'
    },
    listTitleBg: {
        height: '54px',
        backgroundImage: `url(${Background})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100%, 100%',
        marginTop: '30px'
    },
    listTitleText: {
        fontSize: '14px',
        lineHeight: '22px',
        paddingLeft: '20px',
        display: 'flex',
        alignItems: 'center',
    },
    item: {
        height: '54px',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100%, 100%',
    },
}

export default APIAuthorizationInformation